import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';

const { Title } = Typography;

const Overview = () => {
    const { t } = useTranslation();

    return (
        <div className="overview">
            <Title level={3}>{t('welcome')}</Title>
        </div>
    );
};

export default Overview;
